webpackJsonp([82873810758171],{

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '.babelrc'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file contains the settings for the preset and plugins that determine how your project is transpiled.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To learn more about this file, see the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://babeljs.io/docs/usage/babelrc/' },
	        '.babelrc documentation'
	      ),
	      ' on the Babel website.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Note about babel-preset-env'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When you run ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm install'
	      ),
	      ' you may see the deprecation warning below in the console:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      babel-preset-es2015@6.24.1: \uD83D\uDE4C Thanks for using Babel: we recommend using babel-preset-env now: please read babeljs.io/env to update!\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore is intentionally (at least for now) avoiding the use of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'babel-preset-env'
	      ),
	      ' for the following reasons:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'There is an issue where you ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/babel/babel/issues/6604' },
	          'cannot control the preset ordering'
	        ),
	        ', which prevents it from working with some plugins like ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://babeljs.io/docs/plugins/transform-class-properties/' },
	          'transform-class-properties'
	        ),
	        ' and ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/loganfsmyth/babel-plugin-transform-decorators-legacy' },
	          'transform-decorators-legacy'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Those plugins are used for the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'esnext'
	        ),
	        ' version of a Lore project, which means the project types would end up with inconsistent babel configurations.'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Starting in Babel 7, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'transform-decorators'
	      ),
	      ' will ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://babeljs.io/docs/plugins/transform-decorators/' },
	        'be included in Babel\'s Stage-0 presets'
	      ),
	      ', and the configuration will be moving to a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '.babel.js'
	      ),
	      ' file to allow you to programmatically construct your configuration.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Those changes may make it feasible to adopt ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'babel-preset-env'
	      ),
	      ', but in the meantime, if the issues described above don\'t concern you, feel free to change your Babel setup to use ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'babel-preset-env'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default file included in new projects looks like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        {\n          "presets": [\n            "es2015",\n            "react"\n          ],\n          "plugins": []\n        }\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        {\n          "presets": [\n            "es2015",\n            "react"\n          ],\n          "plugins": []\n        }\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        {\n          "presets": [\n            "es2015",\n            "react",\n            "stage-2"\n          ],\n          "plugins": [\n            "transform-decorators-legacy"\n          ]\n        }\n        ' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-babelrc-js-8fd1a06cbdeac56477e1.js